import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { FilterStore, TranslationStore, AccessibilityStore } from '../stores';
import ShareableLinkConfirm from './ShareableLinkConfirm';
import { Theme } from '../models/Theme';

const ShareableLinkButton = styled<any, any>(
    'button',
    'shareableLinkButton',
    'shareableLink'
)`
    ${propStyles};
`;

ShareableLinkButton.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'black',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'body',
    },
};

interface ShareableLinkProps {
    theme?: Theme;
    translationStore?: TranslationStore;
    filterStore?: FilterStore;
    accessibilityStore?: AccessibilityStore;
}
@inject('translationStore', 'filterStore', 'accessibilityStore')
@observer
class ShareableLink extends React.Component<ShareableLinkProps> {
    render() {
        const {
            theme,
            translationStore,
            filterStore,
            accessibilityStore,
        } = this.props;
        return (
            <React.Fragment>
                <ShareableLinkButton
                    aria-label={accessibilityStore.buttonAccessibilityValue(
                        'ShareableLinkButton'
                    )}
                    title={translate(
                        translationStore,
                        filterStore.shareableLinkLabel
                    )}
                    onClick={filterStore.copyShareableLinkToClipboard}
                    data-metric-id={`shareableLink`}
                    {...theme.ShareableLinkButton}
                >
                    <Translate>{filterStore.shareableLinkLabel}</Translate>
                    <Icon
                        height="1.4em"
                        width="1.4em"
                        margin="0 0 0 0.25em"
                        fileName="ShareableLinkIcon"
                        {...theme.ShareableLinkIcon}
                    />
                </ShareableLinkButton>
                <ShareableLinkConfirm />
            </React.Fragment>
        );
    }
}

export default withTheme(ShareableLink);



// WEBPACK FOOTER //
// ./src/Components/ShareableLink.tsx